'use client'

import React from 'react'
import SamanthaRevealProvider from './samantha-reveal-provider'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import { useSellerId } from '@/hooks/useSellerId'

export default function SamanthaRevealProviderConnected() {
  const { userId, firstname, name, user } = useCurrentUser()
  const { sellerId } = useSellerId()

  return (
    <SamanthaRevealProvider
      user={{
        customer_id: userId,
        seller_id: sellerId,
        firstname,
        name,
      }}
      enabled={true}
    />
  )
}
